import * as Sentry from '@sentry/browser';
import { publicAppSync } from '../auth';
import { validateCaptcha } from '../../graphql/queries/captcha.query';

export default class CaptchaProvider {
  static async validateCaptcha(token = '') {
    try {
      const { data } = await publicAppSync.client.query({
        query: validateCaptcha(),
        variables: { token },
      });
      return {
        data,
        success: true,
        message: 'success',
      };
    } catch (e) {
      Sentry.captureException(e);
      return {
        data: null,
        success: false,
        message: e.message,
      };
    }
  }
}
